module.exports = __webpack_public_path__ + "static/media/Chinomso Iyasara Resume.61b02722.pdf";